import { APIFunctionNames, COOKIE_GET } from "../api/APIFunctionName";
import { APIRequest } from "../api/APIRequest";
import { APIInputData } from "../api/APIInputData";
import { PHPResponse } from "../PHPResponse";

export class CookieGetInput extends APIInputData
{
  name:string;
}

export class CookieGetResponse extends PHPResponse
{
  value:string;
}

export class CookieGetRequest extends APIRequest<COOKIE_GET,CookieGetInput,CookieGetResponse>
{
  constructor(){ super( APIFunctionNames.COOKIE_GET ); }
}